import { useRouter } from "src/helpers"; // import lodash from 'lodash';
// import deepdash from 'deepdash-es';

import { withCreatePlan } from "src/modules/plan/operations";
import { compose } from "src/helpers";

import CreateView from "./component";

const Create = (props) => {
    const { createPlan } = props;
    const router = useRouter();

    const onFinish = async (values: any) => {
        await createPlan(values);
        router.push("/plan");
    };

    const onFinishFailed = (errorInfo: any) => {
        console.log("Failed:", errorInfo);
    };

    return <CreateView onFinish={onFinish} onFinishFailed={onFinishFailed} />;
};

export default compose(withCreatePlan)(Create);
